(function () {
  function initCommonQuestions(root) {
    var items = root.querySelectorAll('.faq-item');

    items.forEach(function (item) {
      var row = item.querySelector('.question-row');
      var btn = item.querySelector('.toggle-icon-btn');
      var wrap = item.querySelector('.answer-wrapper');
      if (!row || !btn || !wrap) return;

      function setOpen(open) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        wrap.style.maxHeight = open ? wrap.scrollHeight + 'px' : '0px';
      }

      // Default to collapsed
      setOpen(false);

      row.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        setOpen(!open);
      });
    });

    // Keep open answers sized correctly on resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        items.forEach(function (item) {
          var btn = item.querySelector('.toggle-icon-btn');
          var wrap = item.querySelector('.answer-wrapper');
          if (btn && wrap && btn.getAttribute('aria-expanded') === 'true') {
            wrap.style.maxHeight = wrap.scrollHeight + 'px';
          }
        });
      }, 150);
    });
  }

  function boot() {
    document.querySelectorAll('.common-questions').forEach(initCommonQuestions);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.common-questions');
    if (el) initCommonQuestions(el);
  });
})();
